// Hostnames where default CAMS styling should be used (no whitelabel)
const DEFAULT_CAMS_HOSTNAMES = [
  'localhost',
  'mycardholdersupport.com',
  'dev.mycardholdersupport.com',
  'staging.mycardholdersupport.com',
  'mycard.mycardholdersupport.com',
];

/**
 * Check if the current hostname is a default CAMS hostname.
 * Default CAMS hostnames use standard CAMS styling (decorative elements, default colors).
 * Non-default hostnames use whitelabel styling from the theme.
 * @returns {boolean} True if current hostname is a default CAMS hostname
 */
export const isCAMSDefaultHost = () => {
  if (typeof window === 'undefined') return true;
  return DEFAULT_CAMS_HOSTNAMES.includes(window.location.hostname);
};
